module.exports = __webpack_public_path__ + "media/images/home-old-5acadb8b0d507af05822d58b73b62c5c.jpg";